import { render, staticRenderFns } from "./ConfigTabRanks.vue?vue&type=template&id=f2b7213e"
import script from "./ConfigTabRanks.vue?vue&type=script&lang=js"
export * from "./ConfigTabRanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports